import SEO from "@/components/SEO";

export default function PrivacyPage() {
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-16">
      <SEO title="Privacy Policy" description="How Noxi collects, uses and protects your data — accounts, payments, verifications and marketplace activity."/>
      <div className="overline text-primary mb-2">◆ PRIVACY POLICY</div>
      <h1 className="text-4xl font-bold tracking-tight mb-2">Your data, straight talk.</h1>
      <p className="mono text-xs opacity-60 mb-10">Last updated: 18 Sep 2026</p>

      <div className="space-y-6 text-foreground/90 leading-relaxed text-[15px]">
        <Section n="1" title="What we collect">
          <ul className="list-disc pl-5 space-y-1">
            <li><b>Account info</b> — name, email (via Google), profile photo.</li>
            <li><b>Seller onboarding</b> — mobile, address, bank details, government ID number and image (stored securely via object storage).</li>
            <li><b>Marketplace activity</b> — gigs, orders, messages, reviews, disputes and attachments.</li>
            <li><b>Payments</b> — processed by Stripe or Razorpay; we store only the payment reference, never full card / bank data.</li>
            <li><b>Technical</b> — device, browser, IP address, usage events used for security and product analytics.</li>
          </ul>
        </Section>
        <Section n="2" title="How we use it">
          To operate the marketplace, process payments and payouts, verify seller identity, prevent fraud, respond to support and disputes, send transactional emails, and improve the product.
        </Section>
        <Section n="3" title="Who can see your info">
          <ul className="list-disc pl-5 space-y-1">
            <li><b>Other users</b> only see your public profile — name, photo, bio, ratings, gigs.</li>
            <li><b>Counterparties on an order</b> see requirements, messages and deliverables you share.</li>
            <li><b>Admins</b> see verification documents and bank details strictly for payouts and dispute resolution.</li>
            <li><b>Payment providers</b> (Stripe, Razorpay) process card / bank data under their own policies.</li>
          </ul>
        </Section>
        <Section n="4" title="Data retention">
          Account data is retained while your account is active. On deletion request, we anonymise or delete personal data within 30 days, except records we're legally required to keep (tax, anti-fraud).
        </Section>
        <Section n="5" title="Your rights">
          You can access, correct or delete your data by emailing us. In most jurisdictions you also have the right to portability and to object to certain processing.
        </Section>
        <Section n="6" title="Security">
          TLS everywhere, encryption at rest, principle-of-least-privilege access to admin tools, and periodic reviews. No system is 100% secure — please pick a strong Google account password and enable two-factor auth.
        </Section>
        <Section n="7" title="Cookies">
          We use minimal cookies for session and preferences (currency, theme). No third-party ad tracking.
        </Section>
        <Section n="8" title="Contact">
          Privacy questions? Email <a className="text-primary" href="mailto:noxiiservices@gmail.com">noxiiservices@gmail.com</a>.
        </Section>
      </div>
    </div>
  );
}

function Section({ n, title, children }) {
  return (
    <div>
      <h2 className="text-lg font-semibold mb-2">{n}. {title}</h2>
      <div className="text-foreground/80">{children}</div>
    </div>
  );
}
